<template>
    <div class="convert-header" :class="[stage]">
        <div class="text-center title" v-if="showTitle">
            <template v-if="!showResult">
                {{ lbl.convert.title.convert }} {{ blobConfig.appName
                }}<br />
                {{ lbl.convert.title.textTo }} {{ toApp }}
            </template>
            <template v-else> {{ lbl.result.successfully }} </template>
        </div>
        <div class="flex flex-row w-full" style="min-width: 0px">
            <div class="text-center flex-1">
                <div class="logo-wrapper">
                    <img class="mx-auto" :src="blobConfig.appImgUrl" />
                </div>
                <template v-if="hasMode">
                    <div class="info">
                        <div class="point ff-semi leading-none" v-if="mode == 'point'">
                            {{ FilterNumberFormat(pointRaw) }}
                        </div>
                        <div class="name">{{ blobConfig.appName }}</div>
                    </div>
                </template>
            </div>
            <div class="flex-none">
                <img class="arrow-right" :src="blobConfig.arrowUrl" />
            </div>
            <div class="text-center flex-1">
                <div class="logo-wrapper">
                    <img class="mx-auto" src="@/module/TheOne/assets/logo/logo@2x.png" />
                </div>
                <template v-if="hasMode">
                    <div class="info">
                        <div class="point ff-semi leading-none" v-if="mode == 'point'">
                            {{ FilterNumberFormat(pointConverted) }}
                        </div>
                        <div class="name">{{ toApp }}</div>
                    </div>
                </template>
            </div>
        </div>

        <template v-if="user != null">
            <!-- #TheOne Profile -->
            <template v-if="!hideProfile">
                <div class="px-3 pt-4 text-center text-15 mb-1">
                    {{ lbl.convert.theOneNumber }} {{ cardNo }}
                </div>
                <div class="px-3 text-center text-15">
                    {{ lbl.convert.theOneName }} {{ theOneFullName }}
                </div>
            </template>
            <!-- #EndTheOne Profile -->
        </template>
        <template v-else>
            <BtnLogin @onClickLogin="onClickLogin"></BtnLogin>
        </template>

        <template v-if="showCurrentPoint">
            <div class="current-point px-3 text-center">
                <div class="font-15 mb-1">{{ currentPointLabel }}</div>
                <div class="font-25 text-gray leading-none">
                    {{ FilterNumberFormat(points) }}
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Utility from "@/helper/Utility";
import TimerHelper from "@/helper/TimerHelper";
import BtnLogin from "../Button/BtnLogin.vue";

export default {
    name: "ConvertHeader",
    props: {
        lbl: {
            type: Object,
        },
        userProfile: {
            type: Object
        },
        mode: {
            type: String,
            default: "name", // name, point,
        },
        showResult: {
            type: Boolean,
            default: false,
        },
        showCurrentPoint: {
            type: Boolean,
            default: false,
        },
        hideProfile: {
            type: Boolean,
            default: false,
        },
        stage: {
            type: String,
        },
        toApp: {
            type: String,
            default: "The 1 Points",
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        expiresIn: {
            type: Number,
            default: () => 1 * 60,
        },
        pointRaw: {
            type: Number,
            default: 0
        },
        pointConverted: {
            type: Number,
            default: 0
        }
    },
    components: { BtnLogin },
    inject: ["AccountStore", "LandingStates", "TransferPointStates", "TheOneService", "LocaleStore"],
    mixins: [],
    emits: ["onTranExpire", "onClickLogin"],
    data: function () {
        return {
            timer: new TimerHelper(),
            isTimeExpired: false,
        };
    },
    computed: {
        hasMode: function () {
            return !Utility.isEmptyStr(this.mode);
        },
        currentPointLabel: function () {
            return Utility.stringFormat(
                this.lbl.convert.current_point,
                this.blobConfig.appName
            );
        },
        points: function () {
            return this.TheOneService.userPoints.value;
        },
        transDetail: function () {
            return this.TransferPointStates.resultCheck;
        },
        blobConfig: function () {
            return this.LandingStates.appConfig;
        },
        user: function () {
            if (this.TheOneService.hasSignedIn.value) {
                return this.TheOneService.userTheOne.value
            }
            return null
        },
        cardNo: function () {
            if (this.user != null) {
                return this.user.cards?.[0]?.cardNo ?? '-'
            }
            return '-'
        },
        theOneFullName: function () {
            if (this.user != null) {
                if (this.LocaleStore.localeCode.value == 1033) {
                    return `${this.user.firstName.en} ${this.maskLastName(this.user.lastName.en)}`
                } else {
                    return `${this.user.firstName.th} ${this.maskLastName(this.user.lastName.th)}`
                }
            }
            return '-'
        }
    },
    methods: {
        /**
         *
         * @param {string} val
         */
        maskLastName: function (val) {
            const marker = function (len) {
                let idx = 0;
                let str = ''
                while (idx < len) {
                    idx++
                    str += 'X'
                }
                return str
            }
            if (val.length < 5) {
                let fill = val.length - 1
                let fillStr = marker(fill)

                return `${val[0]}${fillStr}`
            } else {
                let fillStr = marker(4)
                let prefix = val.substring(0, val.length - 4)
                return `${prefix}${fillStr}`
            }
        },
        onClickLogin: function () {
            this.$emit("onClickLogin")
        }
    },
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";

.convert-header {
    @extend %base-class;
    color: $gray;

    &.init {
        margin-bottom: 50px;
    }

    &.tier {
        margin-bottom: 20px;
    }

    &.result {
        margin-bottom: 40px;

        .title {
            margin-bottom: 36px;
        }
    }

    .info {
        margin-top: 15px;

        .name {
            font-size: 13px;
            color: #aaaaaa;
        }

        .point {
            font-size: 15px;
            font-weight: 600;
        }
    }

    .title {
        font-size: 15px;
        color: $gray;
        margin-bottom: 12px;
    }

    .arrow-right {
        margin-top: 24.5px;
        max-height: 31px;
    }

    .logo-wrapper {
        img {
            height: 80px;
            width: 80px;
        }
    }

    .current-point {
        margin-top: 20px;
    }

    .leading-none {
        line-height: 1rem;
    }

    .text-red {
        color: $red;
    }
}
</style>
